import sideMenu from './sideMenu';

export default {
	sideMenu
};



// WEBPACK FOOTER //
// ./src/staticData/index.js